/* Ad-notice logic (legacy 2.9 mechanism), corrected 2026-08-17 against REAL browser data.
   The red "please whitelist us" notice (#justall0wth3d4mn4d) is shown ONLY when an
   ad-blocker is present; otherwise it stays hidden and the ad iframe renders normally.
   The legacy operator marker element with id 'f0rr34lm4nc0me0n' still suppresses the
   notice if present in the document.

   VERIFIED GROUND TRUTH (operator console runs, 2026-08-17):
     Chrome, no blocker .... cosmetic probe NOT hidden; fetch a-ads.com RESOLVES (~350 ms); iframe renders 320x100
     Firefox, uBO off ...... cosmetic probe NOT hidden; fetch a-ads.com RESOLVES (~350 ms); iframe renders 320x100
     Firefox, uBO ON ....... cosmetic probe NOT hidden (their uBO ignores synthetic probes!);
                             fetch a-ads.com REJECTS in ~4 ms (NetworkError); iframe display:none 0x0

   CONSEQUENCES (why this exact design):
   - The COSMETIC probe alone is UNRELIABLE for some uBO configs (it stayed visible even with
     uBO on) — so it can only be a SECONDARY "or" signal, never the sole detector.
   - A no-cors fetch() RESOLVES (opaque response) whenever the request is allowed, and REJECTS
     when a blocker aborts it. That reject is fast (~4 ms) and unambiguous: an allowed-but-
     erroring ad still RESOLVES (opaque responses always resolve regardless of HTTP status),
     only a genuine network ABORT rejects. So fetch reject = blocked, resolve = not blocked.
   - The old 4 s iframe-load timeout was the real Chrome false positive: it attached a `load`
     listener to an iframe that had ALREADY loaded (listener never fires) so only the timeout
     could settle it -> wrongful notice. Removed entirely. No timers, no load-listener race.
   - REJECT IS AMBIGUOUS UNDER LOAD (2026-08-31): a blocker aborts deterministically (rule
     match), but connection-level failures do too — refresh-mashing stacks loads onto the same
     host and an ALLOWED request can get RST'd (dead keep-alive reuse / per-host pool exhaustion)
     and reject exactly like a block. Operator-observed: non-blocker stuck with the notice WHILE
     the ad iframe rendered (a real blocker would abort both). Fix: one retry after 150 ms;
     only two consecutive rejects conclude "blocked". A real blocker aborts both attempts every
     time, so detection never regresses; a transient RST almost always clears on the second draw.
 */
(function() {
  var NOTICE_ID = 'justall0wth3d4mn4d';
  var MARKER_ID = 'f0rr34lm4nc0me0n'; // legacy operator suppressor: never show if present

  function showNotice() {
    if (document.getElementById(MARKER_ID)) { return; }
    var el = document.getElementById(NOTICE_ID);
    if (el) { el.style.display = 'block'; }
    // The red row adds a THIRD line to the fixed #topNav. Side catalog keys off
    // this class (body.adblockNotice -> larger top clearance in _sideCatalog.scss)
    // so it clears the grown nav with no continuous height-watching script — just
    // this one event-driven offset, fired only for ad-blocker users.
    document.body.classList.add('adblockNotice');
  }

  /* Secondary signal: is our EasyList-named probe force-hidden by a cosmetic filter?
     Only ever ADDS evidence of a blocker (our own CSS never hides these names), so it can't
     cause a false positive; it just catches blockers that hide cosmetically. */
  function cosmeticProbeHidden() {
    var probe = document.createElement('div');
    probe.id = 'ad_banner';
    probe.className = 'adsbox ad-slot divAd adWrapper ads-container adsbygoogle advertisement';
    probe.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:10px;overflow:hidden;';
    document.body.appendChild(probe);
    var hidden = false;
    try { hidden = window.getComputedStyle(probe).display === 'none'; } catch (e) {}
    if (probe.parentNode) { probe.parentNode.removeChild(probe); }
    return hidden;
  }

  /* One probe attempt. resolve -> not blocked (final). reject -> ambiguous:
     could be a blocker, could be a connection-level failure under load — so
     the caller retries once before concluding. */
  function probeAttempt(onAmbiguous) {
    try {
      fetch('https://ad.a-ads.com/favicon.ico', { mode: 'no-cors', cache: 'no-store' })
        .then(function() { onAmbiguous(false); }, function() { onAmbiguous(true); });
    } catch (e) {
      onAmbiguous(true);
    }
  }

  function detect() {
    // Fast positive: a blocker's cosmetic filter hides the probe.
    if (cosmeticProbeHidden()) { showNotice(); return; }

    // Primary signal: fetch the ad domain. Resolve = allowed (final). Reject
    // = ambiguous -> one retry after a beat (see header note); only two
    // consecutive rejects conclude "blocked" and show the notice.
    if (typeof window.fetch !== 'function') { return; } // no fetch -> rely on cosmetic only
    var settled = false;
    var finish = function(blocked) { if (settled) { return; } settled = true; if (blocked) { showNotice(); } };
    probeAttempt(function(ambiguous) {
      if (!ambiguous) { finish(false); return; }
      setTimeout(function() {
        probeAttempt(function(rejectedAgain) { finish(rejectedAgain); });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detect);
  } else {
    detect();
  }
})();
